import React from 'react';

import AddButton from '../../components/Buttons/AddButton';

export default function CrudPageLayout({
  children,
  title,
  backgroundColorClass,
  addButtonLabel,
  addButtonOnClick,
}) {
  return (
    <div className="h-full">
      <section
        className={`${backgroundColorClass || 'bg-white dark:bg-gray-900'} h-full`}
      >
        <div className="py-8 px-4 mx-auto max-w-2xl lg:py-16">
          <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-2">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white">
              {title}
            </h2>
            {addButtonLabel && (
              <AddButton label={addButtonLabel} onClick={addButtonOnClick} />
            )}
          </div>
          {children}
        </div>
      </section>
    </div>
  );
}
